import { useContactsState, useMainState } from "modules/app/contexts";
import { setCustomerTags } from "modules/app/utils/http";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import * as S from "./styles";

export default function Tags() {
  const { currentContact } = useContactsState();
  const { tags } = useMainState();
  const [value, setValue] = useState([]);
  const { t } = useTranslation();

  async function handleAdd(event, value) {
    setValue(value);
    const choosedTags = value.map((v) => v.id);
    await setCustomerTags(currentContact.id, choosedTags);
    toast.success(t("TagsManager:tagsUpdated"));
  }

  useEffect(() => {
    setValue(currentContact.customer_tag_ids);
  }, [currentContact.id]);

  return (
    <S.TagsPicker
      multiple
      id="tags-filled"
      options={tags}
      getOptionLabel={(tag) => tag.name}
      getOptionSelected={(option, value) => option.id === value.id}
      ListboxProps={{ style: { maxHeight: 200, overflow: "auto" } }}
      value={value ?? []}
      onChange={handleAdd}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <S.Tag
            size="small"
            key={option.id}
            variant="outlined"
            label={option.name}
            {...getTagProps({ index })}
          />
        ))
      }
      renderInput={(params) => (
        <S.TagInput
          {...params}
          variant="standard"
          label={t("Customer:details.tags.clickToAddTagLabel")}
          InputLabelProps={{
            style: {
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
              width: "100%",
              color: "#111111",
              fontSize: "14px",
              textAlign: "center",
            },
          }}
        />
      )}
    />
  );
}
